import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { c } from '@debbie/cortex/dist/index.js';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors.js';
import { ButtonGroup, Button } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const UpdatesGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    const updateTypes = useSelector(selectUpdateTypes);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.updatesGroup },
        React.createElement(FilterOption, { active: typeof caseFilter.isPaused === 'boolean', header: lang.caseFilter.caseIsCurrently, onDeactivate: () => c.insights.clearFilter('isPaused') },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isPaused === true, onClick: (e) => c.insights.updateFilter({
                        isPaused: true,
                    }) }, lang.caseFilter.paused),
                React.createElement(Button, { size: "small", theme: "secondary", disabled: caseFilter.isPaused === false, onClick: (e) => c.insights.updateFilter({
                        isPaused: false,
                    }) }, lang.caseFilter.notPaused))),
        React.createElement(FilterOption, { active: !!(caseFilter.hasUpdateIds && caseFilter.hasUpdateIds.length), header: lang.caseFilter.hasFollowingStatus, subheader: lang.caseFilter.hasFollowingStatusSub, onDeactivate: () => c.insights.clearFilter('hasUpdateIds') },
            React.createElement(Select, { value: (caseFilter.hasUpdateIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        hasUpdateIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.doNotHaveUpdateIds &&
                caseFilter.doNotHaveUpdateIds.length), header: lang.caseFilter.doNotHaveFollowingStatus, subheader: lang.caseFilter.doNotHaveFollowingStatusSub, onDeactivate: () => c.insights.clearFilter('doNotHaveUpdateIds') },
            React.createElement(Select, { value: (caseFilter.doNotHaveUpdateIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        doNotHaveUpdateIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.hasCurrentPauseIds &&
                caseFilter.hasCurrentPauseIds.length), header: lang.caseFilter.isPausedFollowingStatus, subheader: lang.caseFilter.isPausedFollowingStatusSub, onDeactivate: () => c.insights.clearFilter('hasCurrentPauseIds') },
            React.createElement(Select, { value: (caseFilter.hasCurrentPauseIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        hasCurrentPauseIds: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.doNotHaveCurrentPauseIds &&
                caseFilter.doNotHaveCurrentPauseIds.length), header: lang.caseFilter.isNotPausedFollowingStatus, subheader: lang.caseFilter.isNotPausedFollowingStatusSub, onDeactivate: () => c.insights.clearFilter('doNotHaveCurrentPauseIds') },
            React.createElement(Select, { value: (caseFilter.doNotHaveCurrentPauseIds || []).map((updateTypeId) => {
                    const updateType = updateTypesMap[updateTypeId];
                    return {
                        label: lang.updateTypes[updateTypeId] ||
                            (updateType && updateType.label) ||
                            updateType,
                        value: updateTypeId,
                    };
                }), isMulti: true, placeholder: lang.caseFilter.selectStatus, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                    label: lang.updateTypes[updateType.updateTypeId] || updateType.label,
                    value: updateType.updateTypeId,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        doNotHaveCurrentPauseIds: selected,
                    });
                } }))));
};
export default UpdatesGroup;
//# sourceMappingURL=UpdatesGroup.js.map